import React, { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import DefaultCard from '../../../components/default/DefaultCard';
import ButtonCreate from '../../../components/buttons/ButtonCreate';
import DefaultModal from '../../../components/default/DefaultModal';
import { useHistory } from 'react-router-dom';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';
import { Items } from '../../../app/shared/enums';
import { BatchDetailDataForm, BatchDetailFilters } from '../../../app/models/BatchDetail';
import useBatchDetailService from '../../../app/services/hooks/useBatchDetailService';
import BatchDetailDataTable from './tables/BatchDetailDataTable';

interface Props {
    batchId: number;
    isShow?: boolean;
}

const BatchDetailAccountingContainer = ({ batchId, isShow = false }: Props) => {
    const history = useHistory();
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const { getBatchDetailAccountingsByBatch, fetchingGetBatchDetailAccountingsByBatch } =
        useBatchDetailService();

    const [showingShow, setShowingShow] = useState(false);

    const [batchDetailIdShow, setBatchDetailIdShow] = useState<number>(-1);
    const [position, setPosition] = useState<number>(0);
    const [batchDetails, setBatchDetails] = useState<BatchDetailDataForm[]>([]);
    const [totalRows, setTotalRows] = useState<number>(0);

    const [filter, setFilter] = useState<BatchDetailFilters>({
        page: 1,
        per_page: 10,
        sort: 'id',
        order: 'desc'
    });

    useEffect(() => {
        reloadTable();
    }, []);

    const reloadTable = () => {
        getBatchDetailAccountingsByBatch(filter, batchId, {
            onSuccess: (response: ServiceResponse) => {
                setBatchDetails(response.data.batch_details);
                setTotalRows(response.data.total_rows);
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message);
            }
        });
    };

    const showShow = (batchDetailId: number) => {
        setShowingShow(true);
        setBatchDetailIdShow(batchDetailId);
    };

    const hideShow = () => {
        setShowingShow(false);
        setBatchDetailIdShow(-1);
    };

    return (
        <>
            <DefaultCard>
                <div className="row">
                    <div className="col-12">
                        {isShow ? (
                            <BatchDetailDataTable
                                batchDetails={batchDetails}
                                loading={fetchingGetBatchDetailAccountingsByBatch}
                                totalRows={totalRows}
                                filter={filter}
                                setFilter={setFilter}
                            />
                        ) : (
                            <BatchDetailDataTable
                                batchDetails={batchDetails}
                                loading={fetchingGetBatchDetailAccountingsByBatch}
                                totalRows={totalRows}
                                filter={filter}
                                setFilter={setFilter}
                            />
                        )}
                    </div>
                </div>
            </DefaultCard>

            {/* {showingShow ? (
                <DefaultModal
                    show={showingShow}
                    handleClose={hideShow}
                    title={`Ver detalle lote`}
                    backdrop={true}
                    showFooter={false}
                >
                    <BatchDetailshow
                        batchDetailId={batchDetailIdShow}
                        onCancel={hideShow}
                        onError={hideShow}
                    />
                </DefaultModal>
            ) : null}   */}
        </>
    );
};

export default BatchDetailAccountingContainer;
